import { render } from "./shopifyVedio.vue?vue&type=template&id=14d9b841&scoped=true"
import script from "./shopifyVedio.vue?vue&type=script&lang=js"
export * from "./shopifyVedio.vue?vue&type=script&lang=js"

import "./shopifyVedio.vue?vue&type=style&index=0&id=14d9b841&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d9b841"]])

export default __exports__